import { render, staticRenderFns } from "./EventAttendAlert.vue?vue&type=template&id=f9a0035c"
import script from "./EventAttendAlert.vue?vue&type=script&lang=ts"
export * from "./EventAttendAlert.vue?vue&type=script&lang=ts"
import style0 from "./EventAttendAlert.vue?vue&type=style&index=0&id=f9a0035c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports